import { NaviTableColumnDef } from '@cp/src/components/NaviTable/interfaces';
import { QcAgentAudit } from '../interface';
import { getStatusDisplay, getAuditStatusColor } from '../utils';
import { DateFormat, getFormatDate } from '@cp/src/utils/DateHelper';
import Tag from '@navi/web-ui/lib/primitives/Tag';
import { Typography } from '@navi/web-ui/lib/primitives';

export const getQcAgentColumns = (): NaviTableColumnDef<QcAgentAudit>[] => [
  {
    accessorKey: 'dateOfAllocation',
    header: 'Date of Allocation',
    cell: info => getFormatDate(info.getValue() as string, DateFormat.DD_MMM_YYYY__hh_mm_a)
  },
  {
    accessorKey: 'auditStatus',
    header: 'Audit Status',
    cell: info => {
      const status = info.getValue() as string;
      const { label, suffix } = getStatusDisplay(status);
      return (
        <div className="flex flex-col align-center">
          <div>
            <Tag
              label={label}
              variant="transparent"
              size="sm"
              color={getAuditStatusColor(status)}
            />
          </div>
          {suffix && (
            <Typography
              as="span"
              variant="p5"
              className="font-normal text-[10px] leading-[16px] tracking-[-0.01em]"
              color="var(--grayscale-2)"
            >
              {suffix}
            </Typography>
          )}
        </div>
      );
    }
  },
  {
    accessorKey: 'customerName',
    header: 'Customer Name',
    cell: info => info.getValue() || '-'
  },
  {
    accessorKey: 'caseEntityId',
    header: 'LAN',
    cell: info => info.getValue() || '-'
  }
];
